/**
 * Log diagnostico delle azioni Best Execution sul ciclo di vita delle fonti.
 *
 * Attivo in sviluppo. Per accenderlo su un build (staging, collaudo):
 *   localStorage.setItem('beDebug', '1')   poi ricarica
 * Per spegnerlo:
 *   localStorage.removeItem('beDebug')
 */
const debugAbilitato = (): boolean => {
  try {
    if (localStorage.getItem('beDebug') === '1') return true;
    if (localStorage.getItem('beDebug') === '0') return false;
  } catch {
    // storage non accessibile (private browsing): si ricade sul default
  }
  return process.env.NODE_ENV !== 'production';
};

interface LogAzione {
  /** Il bottone premuto, con le parole della UI. */
  azione: string;
  metodo: string;
  endpoint: string;
  payload?: unknown;
  risposta?: unknown;
  errore?: unknown;
  /** Cosa distingue questa azione dalle altre. */
  nota?: string;
}

export const logAzioneBe = ({
  azione,
  metodo,
  endpoint,
  payload,
  risposta,
  errore,
  nota,
}: LogAzione): void => {
  if (!debugAbilitato()) return;

  const esito = errore ? '✗' : '✓';
  // eslint-disable-next-line no-console
  console.groupCollapsed(`[BE] ${esito} ${azione} — ${metodo} ${endpoint}`);
  // eslint-disable-next-line no-console
  if (nota) console.log('%cCosa fa:', 'font-weight:bold', nota);
  // eslint-disable-next-line no-console
  if (payload !== undefined) console.log('payload:', payload);
  // eslint-disable-next-line no-console
  if (risposta !== undefined) console.log('risposta:', risposta);
  // eslint-disable-next-line no-console
  if (errore !== undefined) console.error('errore:', errore);
  // eslint-disable-next-line no-console
  console.groupEnd();
};
